import axios from '../components/_generic/axiosSplunk/axiosSplunk';
import { URL_GEOLOCATION } from '../config/setup/setup';
import ErrorTrackingService from '../helpers/errorTrackingService';
import httpCommonHeaders from '../helpers/httpCommonHeaders';

export const getGeoLocationData = async (latitude, longitude) => {
  try {
    const { data } = await axios({
      cache: false,
      headers: httpCommonHeaders(),
      method: 'GET',
      url: `${URL_GEOLOCATION}/${latitude}/${longitude}`,

      validateStatus: (status) => {
        return status < 500;
      },

      withCredentials: true,
    });

    return data;
  } catch (error) {
    console.warn(error);
    ErrorTrackingService.logError(error);
  }
};
